import makeStyles from 'e100-react-components/lib/styles/makeStyles';

import type { AutocompleteProps } from './ui';

interface StyleProps extends Pick<
  AutocompleteProps,
  'variant'
> {}

export const useStyles = makeStyles(({
  spacing,
  palette,
  typography,
  zIndex,
  shape
}) => ({
  root: () => ({
    '& fieldset span': {
      fontSize: 10.5
    }
  }),
  inputRoot: ({ variant }: StyleProps) => ({
    padding: `${spacing(0.974)}px ${spacing()}px !important`,

    ...variant === 'filled' && {
      backgroundColor: palette.grey[100],
      borderRadius: shape.borderRadius,

      '&:hover': {
        backgroundColor: palette.grey[300],
      },

      '&:after': {
        display: 'none'
      },
      '&:before': {
        display: 'none'
      }
    }
  }),
  input: {
    fontSize: `${typography.body2.fontSize} !important`,
    marginLeft: spacing(0.5)
  },
  focused: {
    '& > div': {
      borderColor: palette.primary.main,
      backgroundColor: 'transparent'
    }
  },
  popupIndicator: {
    display: 'none'
  },
  clearIndicator: ({ variant }: StyleProps) => ({
    visibility: 'visible',
    ...variant === 'filled' && {
      marginRight: spacing(4)
    }
  }),
  paper: {
    marginTop: spacing()
  },
  popper: {
    zIndex: zIndex.snackbar
  },
  cardDescription: {
    marginTop: spacing()
  }
}));
